export default {
  methods: {
    /**
     * Retrieves a nested value from an object using dot/bracket notation.
     *
     * @param {Object} obj - The source object.
     * @param {String} path - The path string (e.g., "FACMES.MES[0].FACNETA").
     * @returns {*} - The value found or undefined.
     */
    getDeepValue(obj, path) {
      return path
        .replace(/\[(\w+)\]/g, '.$1') // convert [0] to .0
        .split('.')
        .reduce((acc, part) => acc && acc[part], obj);
    },

    /**
     * Detects the type of a value: 'date', 'number', or 'string'.
     *
     * @param {*} value
     * @returns {String} - The detected type.
     */
    detectType(value) {
      if (typeof value === 'string' && !isNaN(Date.parse(value))) return 'date';
      if (!isNaN(Number(value))) return 'number';
      return 'string';
    },

    /**
     * Sorts an array of objects based on a specified nested column path.
     *
     * @param {Object} params
     * @param {Array} params.data - The array of objects to sort.
     * @param {String} params.column - The property key or nested path to sort by.
     * @param {Boolean} [params.orderAsc=true] - Whether to sort in ascending order.
     * @param {String} [params.type] - Optional override for data type: 'string', 'number', or 'date'.
     * @returns {Array} - The sorted array.
     */
    sortByCol({ data, column, orderAsc = true, type = null }) {
      return data.slice().sort((a, b) => {
        const valA = this.getDeepValue(a, column);
        const valB = this.getDeepValue(b, column);

        const actualType = type || this.detectType(valA);

        switch (actualType) {
          case 'number':
            return orderAsc
              ? Number(valA) - Number(valB)
              : Number(valB) - Number(valA);
          case 'date':
            return orderAsc
              ? new Date(valA) - new Date(valB)
              : new Date(valB) - new Date(valA);
          default: // string
            return orderAsc
              ? String(valA).localeCompare(String(valB))
              : String(valB).localeCompare(String(valA));
        }
      });
    },
  },
};
